import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "tab-console" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  class: "empty-data"
}
const _hoisted_4 = {
  key: 1,
  class: "empty-data"
}

import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import store from "@/store";

import { toast } from "@/common/utils/toast";

import {
  consoleGameList,
  consoleGameCreate,
  consoleGameDelete,
} from "@/common/api/rest/console/game";

import type { ConsoleGameType } from "@/common/types/console/game";

import {
  baseConfirm,
  baseModal,
  baseSidebar,
  baseLoading,
  cropImage,
  svgIcon,
  viewImage,
  viewImageList,
} from "@/common/components";

const imageSize = "15rem";


export default /*@__PURE__*/_defineComponent({
  __name: 'games',
  props: {
    consoleId: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v11092de4": (imageSize)
}))

const { t, locale } = useI18n();

const props = __props;

const games = ref<ConsoleGameType[]>([]);
const selected = ref<ConsoleGameType | null>(null);

const loading = ref(true);
const showModalAddImage = ref(false);
const showModalDelImage = ref(false);

async function fetchGames() {
  await consoleGameList(props.consoleId)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        games.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function removeGame(game: ConsoleGameType) {
  selected.value = game;
  showModalDelImage.value = true;
}

function removeGameCancel() {
  showModalDelImage.value = false;
  selected.value = null;
}

async function removeGameConfirm() {
  showModalDelImage.value = false;

  store.commit("SET_LOADING", true);

  await consoleGameDelete(selected.value?.item_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });
        fetchGames();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

onMounted(async () => {
  await fetchGames();
  loading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(baseLoading))
          ]))
        : (games.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(svgIcon), {
                icon: "no-image",
                size: "3rem"
              }),
              _createElementVNode("span", null, _toDisplayString(_unref(t)("collection.texts.no_images")), 1)
            ]))
          : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(baseConfirm), {
      show: showModalDelImage.value,
      title: _unref(t)('collection.modals.titles.del_game').toUpperCase(),
      message: 
        _unref(t)('collection.modals.messages.del_game', {
          name: selected.value?.name?.toUpperCase(),
        })
      ,
      onCancel: _cache[0] || (_cache[0] = ($event: any) => (removeGameCancel())),
      onConfirm: _cache[1] || (_cache[1] = ($event: any) => (removeGameConfirm()))
    }, null, 8, ["show", "title", "message"])
  ]))
}
}

})